import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ago } from "@/lib/watch";

// Name poll totals for Jack and admins, shown on the Game stats page
// (backend/name_poll.py).
export default function NamePollResults() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/name-poll/results").then(({ data }) => setData(data), () => setError(true));
  }, []);

  const max = data ? Math.max(1, ...data.names.map((n) => n.points)) : 1;

  return (
    <section className="mt-10 max-w-3xl" data-testid="name-poll-results">
      <h2 className="font-display text-xl font-bold tracking-tight">Name poll</h2>
      <p className="text-xs text-muted-foreground mt-1">
        {data
          ? `${data.voters} player${data.voters === 1 ? "" : "s"} voted. A 1st pick scores 5 points, down to 1 for a 5th.`
          : "Loading…"}
      </p>
      {error && <p className="mt-6 text-sm text-red-500">Couldn't load the results.</p>}

      {data && (
        <div className="mt-4 bg-surface border border-border rounded-2xl p-4 sm:p-5 flex flex-col gap-2">
          <div className="grid grid-cols-[1.5rem_1fr_auto] gap-x-3 text-xs text-muted-foreground pb-1">
            <span>#</span>
            <span>Name</span>
            <span className="text-right">Points · 1st picks</span>
          </div>
          {data.names.map((n, i) => (
            <div key={n.name} className="grid grid-cols-[1.5rem_1fr_auto] gap-x-3 items-center text-sm">
              <span className="text-muted-foreground tabular-nums">{i + 1}</span>
              <div className="min-w-0">
                <div className="font-semibold truncate">{n.name}</div>
                <div className="h-1.5 mt-1 rounded-full bg-background overflow-hidden">
                  <div className="h-full bg-brand rounded-full" style={{ width: `${(n.points / max) * 100}%` }} />
                </div>
              </div>
              <span className="text-right tabular-nums" title={`Picked 1st to 5th: ${n.picks.join(", ")}`}>
                {n.points} · {n.first}
              </span>
            </div>
          ))}
        </div>
      )}

      {data && data.votes.length > 0 && (
        <>
          <h3 className="font-display text-base font-bold tracking-tight mt-6">Every vote</h3>
          <div className="mt-3 flex flex-col gap-2">
            {data.votes.map((v) => (
              <div key={v.user_id} className="bg-surface border border-border rounded-xl px-4 py-2.5 text-sm">
                <div className="flex justify-between gap-3">
                  <span className="font-semibold truncate">{v.username || "Unknown player"}</span>
                  <span className="text-xs text-muted-foreground flex-none">{ago(v.created_at)}</span>
                </div>
                <div className="text-muted-foreground">
                  {v.ranking.map((n, i) => `${i + 1}. ${n}`).join("   ")}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  );
}
